var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{staticClass:"html-editor",attrs:{"editorToolbar":_vm.customToolbar,"editorOptions":_vm.editorOptions},on:{"text-change":function($event){return _vm.$emit('text-change', _vm.content)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }